module.exports = __webpack_public_path__ + "static/media/vimeo-front-side.67fefa34.jpg";